<template>
  <svg :class="iconClass">
    <use :xlink:href="require('@/assets/images/svg/svg-map.svg') + '#' + name"></use>
  </svg>
</template>
<script>

export default {
  name: 'f-icon',
  props: {
    name: {
      type: String,
      required: true,
      validator: v => [
        'add-user',
        'archive',
        'attachment',
        'check_circle',
        'clear',
        'done',
        'download',
        'duplicate',
        'edit',
        'info',
        'list',
        'lock',
        'mail',
        'map-pin',
        'inquiry',
        'more',
        'phone',
        'search',
        'star',
        'users'
      ].includes(v)
    }
  },
  computed: {
    iconClass () {
      let iconCSSClass = ['icon'];

      if (this.name) {
        iconCSSClass.push((`icon-${this.name}`).replaceAll('_', '-'));
      }

      return iconCSSClass.join(' ');
    }
  },
}
</script>
